import * as model from "./constants";
import Address, { SHIP_TO } from "./address";

export { model, SHIP_TO };
export default Address;
